import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #242323;
`
const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media (max-width: 950px) {
    flex-direction: column;
  }
`

const ContainerLogoTop = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 950px) {
    min-width: 300px;
    justify-content: space-around;
  }
`

const ContainerLogoBottom = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 950px) {
    min-width: 300px;
    justify-content: space-around;
  }
`

const FinteChileLogo = styled.img`
  width: 84px;
  height: 26px;
`

const EndeavorLogo = styled.img`
  width: 100px;
  height: 15px;
`

const RankiaLogo = styled.img`
  width: 60px;
  height: 19px;
`

const DesafioLogo = styled.img`
  width: 40px;
  height: 22px;
  @media (min-width: 951px) {
    margin-right: 10px;
  }
`

const GreatPlaceToWork = styled.img`
  width: 35px;
  height: 35px;
`

const Partners = () => (
  <Container>
    <Content>
      <ContainerLogoTop>
        <FinteChileLogo src="/fintechile.svg" alt="FinteChile" />
        <EndeavorLogo src="/endeavor-white.svg" alt="Endeavor" />
      </ContainerLogoTop>
      <ContainerLogoBottom>
        <RankiaLogo src="/rankia-white.svg" alt="rankia" />
        <DesafioLogo src="/desafio-10-x.svg" alt="Desafio 10x" />

        <GreatPlaceToWork
          src="/great-place-to-work-white.svg"
          alt="Great Place To Work"
        />
      </ContainerLogoBottom>
    </Content>
  </Container>
)

export default Partners
